(function () {
  'use strict';

  var instances = new WeakMap();
  var ARROW_DISABLED = 'pts-trusted-arrow-disabled.svg';
  var ARROW_ACTIVE = 'pts-trusted-arrow-active.svg';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function TrustedPlayersCarousel(root) {
    this.root = root;
    this.desktopViewport = root.querySelector('[data-trusted-desktop-viewport]');
    this.mobileViewport = root.querySelector('[data-trusted-mobile-viewport]');
    this.prevBtn = root.querySelector('[data-trusted-prev]');
    this.nextBtn = root.querySelector('[data-trusted-next]');
    this.pagination = root.querySelector('[data-trusted-pagination]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-trusted-dot]'));

    this.desktopStep = 434;
    this.mobileStep = 350;
    this.currentIndex = 0;
    this.dragState = null;
    this.scrollRaf = 0;
    this.boundHandlers = {};
    this.resizeObserver = null;

    this.arrowAssets = {
      disabled: this.getAssetUrl(ARROW_DISABLED),
      active: this.getAssetUrl(ARROW_ACTIVE)
    };
  }

  TrustedPlayersCarousel.prototype.getAssetUrl = function (filename) {
    var icon = this.root.querySelector('[src*="' + filename + '"]');
    return icon ? icon.getAttribute('src') : '';
  };

  TrustedPlayersCarousel.prototype.isDesktop = function () {
    return window.matchMedia('(min-width: 750px)').matches;
  };

  TrustedPlayersCarousel.prototype.getActiveViewport = function () {
    return this.isDesktop() ? this.desktopViewport : this.mobileViewport;
  };

  TrustedPlayersCarousel.prototype.getStep = function () {
    return this.isDesktop() ? this.desktopStep : this.mobileStep;
  };

  TrustedPlayersCarousel.prototype.getMaxScroll = function (viewport) {
    if (!viewport) return 0;
    return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  };

  TrustedPlayersCarousel.prototype.getCurrentIndex = function () {
    var viewport = this.getActiveViewport();
    if (!viewport) return 0;
    return Math.round(viewport.scrollLeft / this.getStep());
  };

  TrustedPlayersCarousel.prototype.scrollToIndex = function (index, behavior) {
    var viewport = this.getActiveViewport();
    if (!viewport) return;

    var step = this.getStep();
    var maxScroll = this.getMaxScroll(viewport);
    var target = clamp(index * step, 0, maxScroll);

    viewport.scrollTo({
      left: target,
      behavior: behavior != null ? behavior : prefersReducedMotion() ? 'auto' : 'smooth'
    });

    this.currentIndex = Math.round(target / step);
    this.updateControls();
  };

  TrustedPlayersCarousel.prototype.updateArrowImage = function (button, enabled, direction) {
    if (!button) return;

    var icon = button.querySelector('.pts-trusted__arrow-icon');
    if (!icon) return;

    icon.setAttribute('src', enabled ? this.arrowAssets.active : this.arrowAssets.disabled);
    icon.classList.toggle('pts-trusted__arrow-icon--prev', direction === 'prev');
    icon.classList.toggle('pts-trusted__arrow-icon--next', direction === 'next');
  };

  TrustedPlayersCarousel.prototype.updateControls = function () {
    if (!this.isDesktop()) {
      this.updatePagination();
      return;
    }

    var viewport = this.desktopViewport;
    if (!viewport || !this.prevBtn || !this.nextBtn) return;

    var maxScroll = this.getMaxScroll(viewport);
    var atStart = viewport.scrollLeft <= 1;
    var atEnd = viewport.scrollLeft >= maxScroll - 1;

    this.prevBtn.disabled = atStart;
    this.prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    this.nextBtn.disabled = atEnd;
    this.nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');

    this.updateArrowImage(this.prevBtn, !atStart, 'prev');
    this.updateArrowImage(this.nextBtn, !atEnd, 'next');

    this.currentIndex = this.getCurrentIndex();
  };

  TrustedPlayersCarousel.prototype.updatePagination = function () {
    if (!this.pagination || !this.dots.length) return;

    var index = this.getCurrentIndex();

    this.dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  TrustedPlayersCarousel.prototype.scheduleSync = function () {
    var self = this;
    if (self.scrollRaf) return;
    self.scrollRaf = window.requestAnimationFrame(function () {
      self.scrollRaf = 0;
      self.updateControls();
    });
  };

  TrustedPlayersCarousel.prototype.snapToNearest = function (viewport) {
    if (!viewport) return;

    var step = viewport === this.desktopViewport ? this.desktopStep : this.mobileStep;
    var maxScroll = this.getMaxScroll(viewport);
    var index = Math.round(viewport.scrollLeft / step);
    var target = clamp(index * step, 0, maxScroll);

    viewport.scrollTo({
      left: target,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });

    this.currentIndex = index;
    this.updateControls();
  };

  TrustedPlayersCarousel.prototype.onPrevClick = function () {
    this.scrollToIndex(this.getCurrentIndex() - 1);
  };

  TrustedPlayersCarousel.prototype.onNextClick = function () {
    this.scrollToIndex(this.getCurrentIndex() + 1);
  };

  TrustedPlayersCarousel.prototype.onDotClick = function (event) {
    var dot = event.currentTarget;
    var index = parseInt(dot.getAttribute('data-trusted-dot-index'), 10);
    if (Number.isNaN(index)) return;
    this.scrollToIndex(index);
  };

  TrustedPlayersCarousel.prototype.onViewportScroll = function () {
    this.scheduleSync();
  };

  TrustedPlayersCarousel.prototype.onViewportPointerDown = function (event) {
    var viewport = event.currentTarget;
    if (event.button !== 0) return;

    this.dragState = {
      viewport: viewport,
      startX: event.clientX,
      startScrollLeft: viewport.scrollLeft,
      dragging: false,
      pointerId: event.pointerId
    };

    viewport.setPointerCapture(event.pointerId);
  };

  TrustedPlayersCarousel.prototype.onViewportPointerMove = function (event) {
    if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

    var viewport = this.dragState.viewport;
    var deltaX = event.clientX - this.dragState.startX;

    if (!this.dragState.dragging && Math.abs(deltaX) >= 4) {
      this.dragState.dragging = true;
      viewport.classList.add('is-dragging');
    }

    if (this.dragState.dragging) {
      event.preventDefault();
      viewport.scrollLeft = this.dragState.startScrollLeft - deltaX;
    }
  };

  TrustedPlayersCarousel.prototype.onViewportPointerUp = function (event) {
    if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

    var viewport = this.dragState.viewport;
    var wasDragging = this.dragState.dragging;

    if (viewport.hasPointerCapture(event.pointerId)) {
      viewport.releasePointerCapture(event.pointerId);
    }

    viewport.classList.remove('is-dragging');
    this.dragState = null;

    if (wasDragging) {
      viewport.dataset.suppressClick = 'true';
      window.setTimeout(function () {
        delete viewport.dataset.suppressClick;
      }, 0);
      this.snapToNearest(viewport);
    }
  };

  TrustedPlayersCarousel.prototype.onViewportClick = function (event) {
    var viewport = event.currentTarget;
    if (viewport.dataset.suppressClick === 'true') {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  TrustedPlayersCarousel.prototype.onResize = function () {
    var viewport = this.getActiveViewport();
    if (!viewport) return;

    var step = this.getStep();
    var maxScroll = this.getMaxScroll(viewport);
    var target = clamp(this.currentIndex * step, 0, maxScroll);

    viewport.scrollLeft = target;
    this.updateControls();
  };

  TrustedPlayersCarousel.prototype.bind = function () {
    var self = this;

    this.boundHandlers.viewportScroll = function () {
      self.onViewportScroll();
    };
    this.boundHandlers.viewportPointerDown = function (event) {
      self.onViewportPointerDown(event);
    };
    this.boundHandlers.viewportPointerMove = function (event) {
      self.onViewportPointerMove(event);
    };
    this.boundHandlers.viewportPointerUp = function (event) {
      self.onViewportPointerUp(event);
    };
    this.boundHandlers.viewportPointerCancel = this.boundHandlers.viewportPointerUp;
    this.boundHandlers.viewportClick = function (event) {
      self.onViewportClick(event);
    };
    this.boundHandlers.prevClick = function () {
      self.onPrevClick();
    };
    this.boundHandlers.nextClick = function () {
      self.onNextClick();
    };
    this.boundHandlers.dotClick = function (event) {
      self.onDotClick(event);
    };
    this.boundHandlers.resize = function () {
      self.onResize();
    };

    [this.desktopViewport, this.mobileViewport].forEach(function (viewport) {
      if (!viewport) return;

      viewport.addEventListener('scroll', self.boundHandlers.viewportScroll, { passive: true });
      viewport.addEventListener('pointerdown', self.boundHandlers.viewportPointerDown);
      viewport.addEventListener('pointermove', self.boundHandlers.viewportPointerMove);
      viewport.addEventListener('pointerup', self.boundHandlers.viewportPointerUp);
      viewport.addEventListener('pointercancel', self.boundHandlers.viewportPointerCancel);
      viewport.addEventListener('click', self.boundHandlers.viewportClick, true);
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', this.boundHandlers.prevClick);
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', this.boundHandlers.nextClick);
    }

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', self.boundHandlers.dotClick);
    });

    this.resizeObserver = new ResizeObserver(this.boundHandlers.resize);
    if (this.desktopViewport) this.resizeObserver.observe(this.desktopViewport);
    if (this.mobileViewport) this.resizeObserver.observe(this.mobileViewport);
  };

  TrustedPlayersCarousel.prototype.unbind = function () {
    var self = this;

    [this.desktopViewport, this.mobileViewport].forEach(function (viewport) {
      if (!viewport) return;

      viewport.removeEventListener('scroll', self.boundHandlers.viewportScroll);
      viewport.removeEventListener('pointerdown', self.boundHandlers.viewportPointerDown);
      viewport.removeEventListener('pointermove', self.boundHandlers.viewportPointerMove);
      viewport.removeEventListener('pointerup', self.boundHandlers.viewportPointerUp);
      viewport.removeEventListener('pointercancel', self.boundHandlers.viewportPointerCancel);
      viewport.removeEventListener('click', self.boundHandlers.viewportClick, true);
    });

    if (this.prevBtn) {
      this.prevBtn.removeEventListener('click', this.boundHandlers.prevClick);
    }
    if (this.nextBtn) {
      this.nextBtn.removeEventListener('click', this.boundHandlers.nextClick);
    }

    this.dots.forEach(function (dot) {
      dot.removeEventListener('click', self.boundHandlers.dotClick);
    });

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.scrollRaf) {
      window.cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = 0;
    }
  };

  TrustedPlayersCarousel.prototype.init = function () {
    this.bind();
    this.updateControls();
  };

  TrustedPlayersCarousel.prototype.destroy = function () {
    this.unbind();
    this.dragState = null;
  };

  function initCarousel(root) {
    if (!root || instances.has(root)) return;

    var instance = new TrustedPlayersCarousel(root);
    instance.init();
    instances.set(root, instance);
  }

  function destroyCarousel(root) {
    var instance = instances.get(root);
    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  }

  function boot(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-pts-trusted-players]').forEach(initCarousel);
  }

  function handleSectionLoad(event) {
    boot(event.target);
  }

  function handleSectionUnload(event) {
    event.target.querySelectorAll('[data-pts-trusted-players]').forEach(destroyCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
})();
